
import Home01 from './Home01';


import AboutUs from './AboutUs';
import Sami from './Sami';
import Aliwen from './Aliwen';
import Killa from './Killa';
import Wayta from './Wayta';
import Wayiki from './Wayiki';
import Nina from './Nina';
import Inti from './Inti';
import Chaski from './Chaski';
import Amaru from './Amaru';
import Pacha from './Pacha';
import Shangu from './Shangu';

import Nosotros from './Nosotros';

import Habitaciones from './Habitaciones';

import FAQ from './FAQ';
import Contact from './Contact';
import QueHacer from './Que-hacer';
import SereviciosRodex from './ServiciosRodex';

const routes = [
  { path: '/', component: <Home01 /> },

  { path: '/about', component: <AboutUs /> },
  { path: '/sami', component: <Sami /> },
  { path: '/aliwen', component: <Aliwen /> },
  { path: '/killa', component: <Killa /> },
  { path: '/wayiki', component: <Wayiki /> },
  { path: '/wayta', component: <Wayta /> },
  { path: '/nina', component: <Nina /> },
  { path: '/inti', component: <Inti /> },
  { path: '/chaski', component: <Chaski /> },
  { path: '/amaru', component: <Amaru /> },
  { path: '/pacha', component: <Pacha /> },
  { path: '/shangu', component: <Shangu /> },
  { path: '/servicios-rodex', component: <SereviciosRodex /> },

  { path: '/nosotros', component: <Nosotros /> },

  { path: '/habitaciones', component: <Habitaciones /> },

  { path: '/faq', component: <FAQ /> },
  { path: '/contact', component: <Contact /> },
  { path: '/que-hacer', component: <QueHacer /> },
]

export default routes;